export const FiveSpark = ({ size = 30, dark = false }) => (
  <span className="relative inline-flex items-center justify-center rounded-xl bg-[#FF6B35] shrink-0"
    style={{ width: size, height: size }}>
    <span className="font-fraunces italic font-black text-white leading-none select-none"
      style={{ fontSize: Math.round(size * 0.6), paddingRight: 1 }}>5</span>
    <svg width={Math.round(size * 0.44)} height={Math.round(size * 0.44)} viewBox="0 0 12 12"
      className="absolute" style={{ top: -size * 0.16, right: -size * 0.16 }} aria-hidden="true">
      <path d="M6 0 L7.4 4.1 L11.5 5.5 L7.4 6.9 L6 11 L4.6 6.9 L0.5 5.5 L4.6 4.1 Z"
        fill={dark ? "#FFD8C4" : "#2D2422"} />
    </svg>
  </span>
);

export const BrandMark = ({ size = 30, dark = false, text = true, dot, className = "" }) => {
  const ink = dark ? "#FAF9F6" : "#2D2422";
  const accent = dot || "#FF6B35";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <FiveSpark size={size} dark={dark} />
      {text && (
        <span className="font-outfit font-extrabold tracking-tight leading-none"
          style={{ fontSize: Math.round(size * 0.6), color: ink }}>
          <span className="font-fraunces italic font-black"
            style={{ color: accent, fontSize: Math.round(size * 0.72), marginRight: 1 }}>5</span>ads.ai
        </span>
      )}
    </span>
  );
};
